import React, { useState, useMemo } from 'react';
import './CategoryReport.css';

const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

const CategoryReport = ({ transactions = [] }) => {
  const [viewType, setViewType] = useState('ambos');
  const [isExpanded, setIsExpanded] = useState(false);

  const report = useMemo(() => {
    const map = {};
    transactions.forEach(t => {
      const tipo = (t.type || '').toLowerCase();
      const isInc = ['receita','entrada'].includes(tipo);
      if (viewType !== 'ambos' && !((viewType === 'receita') === isInc)) return;
      const cat = t.category || 'Sem Categoria';
      if (!map[cat]) map[cat] = { total: 0, count: 0 };
      map[cat].total += parseFloat(t.value) || 0;
      map[cat].count += 1;
    });
    const entries = Object.entries(map).sort(([,a],[,b]) => b.total - a.total);
    const grandTotal = entries.reduce((s,[,v]) => s + v.total, 0);
    return { entries, grandTotal };
  }, [transactions, viewType]);

  const COLORS = ['#3b82f6','#8b5cf6','#10b981','#f59e0b','#ef4444','#06b6d4','#ec4899','#84cc16','#f97316','#6366f1'];

  if (!transactions.length) return null;

  return (
    <div className="cat-report">
      <div className="cat-report-header" onClick={() => setIsExpanded(!isExpanded)} style={{ cursor: 'pointer', userSelect: 'none' }}>
        <div className="cat-report-title">
          <span>📊</span>
          <h2 className="cat-title-small">Relatório por Categoria</h2>
        </div>
        <button 
          className={`toggle-btn ${isExpanded ? 'active' : ''}`}
          onClick={(e) => { e.stopPropagation(); setIsExpanded(!isExpanded); }}
        >
          {isExpanded ? '▲ Ocultar' : '▼ Mostrar'}
        </button>
      </div>

      <div className={`cat-report-content ${isExpanded ? 'expanded' : ''}`}>
        <div className="cat-report-tabs-content">
          <div className="cat-report-tabs">
            {['ambos','despesa','receita'].map(t => (
              <button
                key={t}
                className={`cat-tab ${viewType === t ? 'active' : ''}`}
                onClick={() => setViewType(t)}
              >{t === 'ambos' ? 'Visão Geral' : t === 'despesa' ? '📉 Despesas' : '📈 Receitas'}</button>
            ))}
          </div>
        </div>

      {report.entries.length === 0 ? (
        <div className="cat-report-empty">Nenhum lançamento nesta categoria para o período</div>
      ) : (
        <div className="cat-report-list">
          {report.entries.map(([cat, data], i) => {
            const pct = report.grandTotal > 0 ? (data.total / report.grandTotal) * 100 : 0;
            const cor = COLORS[i % COLORS.length];
            return (
              <div key={cat} className="cat-row">
                <div className="cat-row-top">
                  <div className="cat-row-left">
                    <div className="cat-dot" style={{ background: cor }} />
                    <div>
                      <strong className="cat-name">{cat}</strong>
                      <span className="cat-count">{data.count} lançamento{data.count !== 1 ? 's' : ''}</span>
                    </div>
                  </div>
                  <div className="cat-row-right">
                    <span className="cat-value" style={{ color: cor }}>{fmt(data.total)}</span>
                    <span className="cat-pct">{pct.toFixed(1)}%</span>
                  </div>
                </div>
                <div className="cat-bar">
                  <div className="cat-bar-fill" style={{ width: `${pct}%`, background: cor }} />
                </div>
              </div>
            );
          })}
          <div className="cat-total">
            <span>Total</span>
            <strong>{fmt(report.grandTotal)}</strong>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export default CategoryReport;
